import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliButton, Text } from '@lili/lili-frontend-common';
import { Icon, Icons } from '@Components/icon/Icon';
import { ModalTypes } from '@Hooks/modalManager/modal.types';
import { useModal } from '@Hooks/modalManager/useModal';
import { RoutesMap } from '@Router/router.types';
import { useNavigationManager } from '@Router/useNavigationManager';

export const VerificationProcessCompletedModal = () => {
  // Import translation hook with the correct namespace:
  const { t } = useTranslation('nonUsSocure');

  const { navigateToSpecificPage } = useNavigationManager();
  const { setModal } = useModal();

  const handleSubmit = () => {
    setModal({ isActive: false, type: ModalTypes.NONE });
    navigateToSpecificPage(RoutesMap.VERIFICATION_CENTER);
  };

  return (
    <div className='flex w-[509px] h-[469px] flex-col rounded-[12px] bg-surface-primary-bw-01 font-metricR text-text-main-primary px-[35px]'>
      <div className='flex flex-col rounded-[12px] bg-surface-primary-bw-01 w-full font-metricR text-text-main-primary px-[24px]'>
        <div className='text-center flex justify-center items-center mb-[16px] mt-[40px]'>
          <div className='flex items-center'>
            <Icon icon={Icons.Checkmark} />
          </div>
        </div>
      </div>

      <div id='socure-success-title'>
        <div className='flex flex-col items-center '>
          <Heading.H4 fontWeight={FontWeight.SEMIBOLD} className='text-center text-pretty'>
            {t('verificationProcessCompletedModal.titlePartOne')}
          </Heading.H4>
          <Heading.H4 fontWeight={FontWeight.SEMIBOLD} className='text-center text-pretty'>
            {t('verificationProcessCompletedModal.titlePartTwo')}
          </Heading.H4>
        </div>
      </div>

      <div
        id='socure-success-body'
        className='flex flex-col items-center justify-between pt-[27px] pb-[27px]'>
        <div className='flex flex-col items-center'>
          <Text.H8 className='text-text-main-secondary text-center whitespace-pre-line mt-[8px]'>
            {t('verificationProcessCompletedModal.pleaseProceed')}
          </Text.H8>
          <Text.H8 className='text-text-main-secondary text-center mt-1 whitespace-pre-line mb-[24px]'>
            {t('verificationProcessCompletedModal.documentsToComplete')}
          </Text.H8>
        </div>

        <div className='flex flex-col md:flex-row w-[300px] justify-center mt-[43px]'>
          <LiliButton
            title={t('verificationProcessCompletedModal.continueAndUpload')}
            id='continue'
            onClick={handleSubmit}
            isLoading={false}
          />
        </div>
      </div>
    </div>
  );
};
